import store from "../../redux/store";
import { getAccessToken, getInitialLoadedFragmentCount, getIsSendToken, getStatus } from "../../services/baseUrl";
import { isIOS, isFullMobilePortrait, isTouchScreen, isTouchScreenLandscape, isTouchScreenPortrait, isWhiteListUrl, staticFormats } from "../helpers";
import Cookies from "js-cookie";
import { firstQuizQuestion, lastQuizQuestionStatus } from "../../redux/actions/quiz.actions";
import { ConditionName, QuizTypes } from "interfaces";
import { allParams } from "./paramsConditions";
import { VideoDataSliceState } from "redux-share/slices/videoDataSlice";

export const conditions = (type: string) => {
    const {
        trailer,
        params,
        details,
        gif,
        isComplexPortrait,
        isComplexDesktop,
        markers,
        subtitles,
        question,
        emojis,
        onlineViewers,
        alternative_Lives,
        recommendationList,
        multiAudio,
        isLiveError,
        isValidAddress,
        isFetchDetails,
        token,
        selectedOptionId,
        emojiList1,
        emojiList2,
        selectedSubtitle,
        playList,
        videoElementSizeInfo,
        chartPoints,
        isReady
    } = store.getState().videoData;
    const {
        firstPlay,
        lock,
        canPlayVideo,
        qualityLevels,
        manualQuality,
        activeElements,
        isLoading,
        isLive,
        isEnded,
        isAutoPlay,
        play,
        isFullScreen,
        autoQuality,
        showMiniPlayer,
        loadedFragmentsCount
    } = store.getState().controller;
    const {
        trailerPopover,
        settingPopover,
        markersListPopover,
        sharePopover,
        feedbackPopover,
        multiLivesPopover,
        fullRatePopover,
        autoPlayPopover,
        recommendListPopover,
        speedPopover,
        tagsPopover,
        personalMarkersPopover,
        bookmarksPopover,
        chatPopover,
        loginPopover,
        chatEmojisPopover,
        commentPopover,
        playListCardPopover,
        playListPopover,
        pollPopover
    } = store.getState().popovers;
    const { canAddComment, canShowSubmittedComment, commentsCount, comments, commentDefaultMessages } = store.getState().comments;
    const { selectedTags, inputTagSearch } = store.getState().tags;
    const { isLogin, settings, bookmarkId, avatar_url, name, phone_number, videoSettings, showContinuousePlayback } = store.getState().user;
    const { chatEnabled, showChat, defaultMessages, pinMessage } = store.getState().chats;
    const { quiz, chances } = store.getState().quiz;

    switch (type) {
        case ConditionName.showHeader:
            return !firstPlay && canPlayVideo && !autoPlayPopover;
        case ConditionName.showMain:
            return !lock || firstPlay;
        case ConditionName.showFooter:
            return !firstPlay && canPlayVideo;
        case ConditionName.showGif:
            return !firstPlay && params.type === "live" && settings.poll_emoji && gif;
        case ConditionName.showElapsedTime:
            return params.type !== "live" || staticFormats(params.type!);
        case ConditionName.showLiveStatus:
            return params.type === "live" && !firstPlay && !lock && ((isIOS() && isTouchScreenPortrait()) || !isIOS()) && !isEnded;
        case ConditionName.showLiveStatusInComplexPortrait:
            return params.type === "live" && !isEnded;
        case ConditionName.showTouchVolumeBrightness:
            return !firstPlay && isTouchScreenLandscape() && !lock && !isEnded && params.raw !== "true";
        case ConditionName.showBackwardForward:
            return !firstPlay && isTouchScreen() && !lock && params.raw !== "true" && (!isEnded || (isEnded && params.type !== "live"));
        case ConditionName.showPoll:
            return (
                settings.poll_emoji &&
                !firstPlay &&
                question &&
                question.active &&
                !lock &&
                params.type === "live" &&
                ((isIOS() && isTouchScreenPortrait()) || !isIOS())
            );
        case ConditionName.showFullRate:
            return !staticFormats(params.type!) && !firstPlay && params.fullrate === "true" && fullRatePopover !== undefined;
        case ConditionName.showTitle:
            return !staticFormats(params.type!) && params.type !== "live" && params.isGeneral !== "true" && !lock;
        case ConditionName.showSnapShot:
            return (
                !firstPlay &&
                params.portrait !== "true" &&
                params.snapshot === "true" &&
                (!staticFormats(params.type!) || isWhiteListUrl(params.src!))
            );
        case ConditionName.showInstagramEmoji:
            return settings.poll_emoji && emojis && params.type === "live" && !firstPlay && !isComplexPortrait;
        case ConditionName.showEmojiComplexPortrait:
            return settings.poll_emoji && emojis && params.type === "live";
        case ConditionName.showOnlineViewers:
            return !!onlineViewers && onlineViewers > 0 && (!isComplexPortrait || params.quiz === "true");
        case ConditionName.showMultiLivePopover:
            return multiLivesPopover;
        case ConditionName.showMarkerListPopover:
            return markersListPopover;
        case ConditionName.showFullRatePopover:
            return fullRatePopover;
        case ConditionName.showAutoPlayPopover:
            return autoPlayPopover && isEnded && params.portrait === "true" && !showMiniPlayer && recommendationList && recommendationList.length > 0;
        case ConditionName.showRecommendListPopover:
            return recommendListPopover;
        case ConditionName.showSettingPopover:
            return settingPopover;
        case ConditionName.showSpeedPopover:
            return speedPopover;
        case ConditionName.showTagsPopover:
            return tagsPopover;
        case ConditionName.showPersonalMarkerPopover:
            return personalMarkersPopover;
        case ConditionName.showBookmarksPopover:
            return !!bookmarksPopover;
        case ConditionName.showFeedbackPopover:
            return feedbackPopover;
        case ConditionName.showChatPopover:
            return !!chatPopover;
        case ConditionName.showTrailerPopover:
            return trailerPopover;
        case ConditionName.showLoginPopover:
            return loginPopover;
        case ConditionName.showAutoPlayListTouchIcon:
            return (
                isEnded &&
                !autoPlayPopover &&
                isTouchScreenLandscape() &&
                params.portrait === "true" &&
                !isIOS() &&
                !lock &&
                recommendationList &&
                recommendationList.length > 0
            );
        case ConditionName.showMultiLive:
            return alternative_Lives && alternative_Lives.length > 0 && settings.poll_emoji;
        case ConditionName.showBigReplayIcon:
            return isEnded && params.portrait === "true" && isTouchScreen() && ((isIOS() && isTouchScreenPortrait()) || !isIOS());
        case ConditionName.showReplayIcon:
            return params.portrait === "true" && !isIOS() && !isTouchScreen() && showMiniPlayer !== true;
        case ConditionName.showPlayNextIcon:
            return (
                params.portrait === "true" &&
                !isIOS() &&
                (!isTouchScreen() || isTouchScreenLandscape()) &&
                params.isGeneral !== "true" &&
                showMiniPlayer !== true
            );
        case ConditionName.showAutoPlayToggleIcon:
            return (
                params.portrait === "true" &&
                params.isGeneral !== "true" &&
                ((isIOS() && isTouchScreenPortrait()) || !isIOS()) &&
                showMiniPlayer !== true
            );
        case ConditionName.showSettingIcon:
            return !staticFormats(params.type!) && !isIOS();
        case ConditionName.showLikeDislike:
            return (
                !staticFormats(params.type!) && params.portrait === "true" && params.isGeneral !== "true" && !isComplexDesktop && !isComplexPortrait
            );
        case ConditionName.showBanner:
            return firstPlay && details.banner;
        case ConditionName.showBannerStaticFiles:
            return firstPlay && params.cover;
        case ConditionName.showSpeedIcon:
            return params.type !== "live";
        case ConditionName.showShareInSetting:
            return !isComplexPortrait && !isComplexDesktop;
        case ConditionName.showPlayListIcon:
            return playList && playList.length > 0 && (isFullScreen || (!isFullScreen && params.portrait !== "true")) && showMiniPlayer !== true;
        case ConditionName.showPlayListTabTouchscreen:
            return playList && playList.length > 0 && isTouchScreen();
        case ConditionName.showCommentComponent:
            return canAddComment || (!canAddComment && commentsCount > 0);
        case ConditionName.showModuleTitle:
            return params.showModuleTitle === "true";
        case ConditionName.showProgressbar:
            return !(isIOS() && params.type === "live") && !(params.type === "live" && isEnded);
        case ConditionName.showAgeClassification:
            return details.pg_state && !lock;
        case ConditionName.showChat:
            return params.type === "live" && chatEnabled && showChat;
        case ConditionName.showMiniPlayer:
            return showMiniPlayer;
        case ConditionName.showPictureInPicture:
            return showMiniPlayer !== true && !isIOS() && params.site !== "zarebin.ir";
        case ConditionName.showPersonalMarker:
            return params.authentication === "true" && (params.featureSet === undefined || params.featureSet.personalMarker !== "false");
        case ConditionName.showFeedback:
            return params.featureSet === undefined || params.featureSet.feedback !== "false";
        case ConditionName.trackerEnabled:
            return (params.featureSet === undefined || params.featureSet.enableTracker !== "false") && params.quiz !== "true";
        case ConditionName.showTabNavigator:
            return params.authentication === "true" && (params.featureSet === undefined || params.featureSet.profileFooter !== "false");
        case ConditionName.showBookmark:
            return params.authentication === "true" && (params.featureSet === undefined || params.featureSet.bookmark !== "false");
        case ConditionName.shareButton:
            return params.featureSet === undefined || params.featureSet.shareButton !== "false";
        case ConditionName.showVideoUploadTime:
            return params.featureSet === undefined || params.featureSet.videoUploadTime !== "false";
        case ConditionName.showVideoViewers:
            return params.featureSet === undefined || params.featureSet.videoViewers !== "false";
        case ConditionName.showRecommendationList:
            return params.featureSet === undefined || params.featureSet.recommendationList !== "false";
        case ConditionName.showPlaylist:
            return params.featureSet === undefined || params.featureSet.playlist !== "false";
        case ConditionName.show_Chat:
            return params.featureSet === undefined || params.featureSet.chat !== "false";
        case ConditionName.hidePopovers:
            return !markersListPopover && !settingPopover && !feedbackPopover && !sharePopover && !multiLivesPopover;
        case ConditionName.isRaw:
            return params.raw;
        case ConditionName.isParamsPortrait:
            return params.portrait === "true";
        case ConditionName.isComplexPortrait:
            return isComplexPortrait;
        case ConditionName.isComplexDarkModePortrait:
            return isComplexPortrait && params.theme === "dark";
        case ConditionName.isComplexDesktop:
            return isComplexDesktop;
        case ConditionName.isLandscape:
            return window.innerHeight <= window.innerWidth;
        case ConditionName.isTouchScreen:
            return isTouchScreen();
        case ConditionName.isTouchScreenPortrait:
            return isTouchScreenPortrait();
        case ConditionName.isTouchScreenLandscape:
            return isTouchScreenLandscape();
        case ConditionName.isActiveElements:
            return activeElements;
        case ConditionName.isPlay:
            return play;
        case ConditionName.isFirstPlay:
            return firstPlay;
        case ConditionName.isLock:
            return lock;
        case ConditionName.isIOS:
            return isIOS();
        case ConditionName.isIOSLive:
            return isIOS() && params.type === "live";
        case ConditionName.isLoading:
            return isLoading;
        case ConditionName.isLive:
            return isLive;
        case ConditionName.isLiveParam:
            return params.type === "live";
        case ConditionName.isLiveError:
            return isLiveError;
        case ConditionName.isDarkMode:
            return params.theme === "dark";
        case ConditionName.isStaticFormat:
            return staticFormats(params.type!);
        case ConditionName.isEnded:
            return isEnded;
        case ConditionName.isAutoPlay:
            return isAutoPlay;
        case ConditionName.isFullScreen:
            return isFullScreen;
        case ConditionName.isGeneral:
            return params.isGeneral === "true";
        case ConditionName.isValidAddress:
            return isValidAddress;
        case ConditionName.isFetchDetails:
            return isFetchDetails;
        case ConditionName.isAutoQuality:
            return settings.quality === -1;
        case ConditionName.isAuth:
            return token && params.isAuth === "true";
        case ConditionName.isChildClassification:
            return details.pg_state && details.pg_state < 14;
        case ConditionName.isTeenagerClassification:
            return details.pg_state && details.pg_state >= 14 && details.pg_state < 18;
        case ConditionName.isYoungClassification:
            return details.pg_state && details.pg_state >= 18;
        case ConditionName.isSelectedSubtitle:
            return !!subtitles && subtitles.length > 0 && selectedSubtitle;
        case ConditionName.isZarebinSite:
            return params.site === "zarebin.ir";
        case ConditionName.isUserIdsParamsEqualAll:
            return !!params.user_ids && params.user_ids === "all";
        case ConditionName.isMiniPlayer:
            return (params.portrait !== "true" || showMiniPlayer) && videoElementSizeInfo.width < 520;
        case ConditionName.isFullMobilePortrait:
            return isFullMobilePortrait();
        case ConditionName.isLogin:
            return isLogin;
        case ConditionName.isSpinSettingsIcon:
            return settings.quality === -1 ? autoQuality === undefined : settings.quality !== manualQuality;
        case ConditionName.isVttFitHeight:
            return videoElementSizeInfo.height < 600 || isTouchScreen();
        case ConditionName.isBookmark:
            return bookmarkId !== undefined;
        case ConditionName.isPressKeySpace:
            return !lock;
        case ConditionName.isPressKeyK:
            return !lock;
        case ConditionName.isPressKeyI:
            return !lock && !firstPlay && !showMiniPlayer;
        case ConditionName.isPressKeyF:
            return !lock && !firstPlay && !showMiniPlayer;
        case ConditionName.isPressKeyS:
            return params.type !== "live" && !lock && !firstPlay;
        case ConditionName.isPressKeyC:
            return !lock && !firstPlay && !showMiniPlayer && !!subtitles && subtitles.length > 0;
        case ConditionName.isPressKeyArrowRight:
            return !firstPlay && !lock;
        case ConditionName.isPressKeyArrowLeft:
            return !firstPlay && !lock;
        case ConditionName.isPressKeyL:
            return !firstPlay;
        case ConditionName.isPressKeyN:
            return recommendationList && recommendationList.length > 0 && !firstPlay && !lock;
        case ConditionName.isPressKeyQ:
            return alternative_Lives && alternative_Lives.length > 0 && !firstPlay && !lock;
        case ConditionName.isPressKeyE:
            return markers.length !== 0 && !firstPlay && !lock;
        case ConditionName.isPressKeyM:
            return !firstPlay && !lock;
        case ConditionName.isSendTimelineLog:
            return !staticFormats(params.type!);
        case ConditionName.isPointsQuiz:
            return !!quiz && Object.keys(quiz).length > 0 && quiz.type === QuizTypes.Points;
        case ConditionName.isReady:
            return isReady;
        case ConditionName.isSplusEnvironment:
            return getStatus() === "splus";
        case ConditionName.isProduction:
            return getStatus() === "production";
        case ConditionName.isPaymentSuccess:
            return getStatus() === "production";
        case ConditionName.isPopoverOpen:
            return [
                markersListPopover,
                settingPopover,
                sharePopover,
                feedbackPopover,
                multiLivesPopover,
                pollPopover,
                autoPlayPopover,
                recommendListPopover,
                tagsPopover,
                speedPopover,
                playListPopover,
                playListCardPopover,
                commentPopover,
                personalMarkersPopover,
                bookmarksPopover,
                chatPopover,
                chatEmojisPopover,
                trailerPopover,
                loginPopover
            ].some((popover: boolean | undefined) => !!popover);
        case ConditionName.backgroundColorInLightMode:
            return isComplexDesktop || isComplexPortrait;
        case ConditionName.heightScreen:
            return !isComplexPortrait && !isComplexDesktop && !params.height;
        case ConditionName.playByClickPoster:
            return firstPlay && details.banner && !showContinuousePlayback;
        case ConditionName.hasMarkers:
            return markers.length !== 0;
        case ConditionName.hasTitle:
            return details.title;
        case ConditionName.hasDescription:
            return details.description;
        case ConditionName.hasClipboard:
            return navigator && navigator.clipboard && navigator.clipboard.writeText;
        case ConditionName.hasRecommendationList:
            return recommendationList && recommendationList.length > 0;
        case ConditionName.hasTags:
            return details.tag;
        case ConditionName.hasPreviewTime:
            return params.preview === "true";
        case ConditionName.hasEmojis:
            return emojis;
        case ConditionName.hasEmojiList1Or2:
            return (emojis && !!emojis.emoji_list_1) || (emojis && !!emojis.emoji_list_2);
        case ConditionName.hasBanner:
            return details.banner;
        case ConditionName.hasMultiAudio:
            return multiAudio.length > 0;
        case ConditionName.hasDownloadLinks:
            return details.download_links.length > 0 && (params.featureSet === undefined || params.featureSet.downloadUrl !== "false");
        case ConditionName.hasStreamLink:
            return details.stream_link;
        case ConditionName.hasPoll:
            return question && Object.keys(question).length > 0;
        case ConditionName.hasUserIds:
            return !!params.user_ids;
        case ConditionName.hasAlternativeLives:
            return alternative_Lives && alternative_Lives.length > 0;
        case ConditionName.hasManualQuality:
            return manualQuality !== undefined && manualQuality !== null;
        case ConditionName.hasSound:
            return !!settings.volume;
        case ConditionName.hasVtt:
            return !!details.vtt || !!details.vtt_mobile;
        case ConditionName.hasAutoPlay:
            return params.autoplay === "true";
        case ConditionName.hasPlayList:
            return playList && playList.length > 0 && ((isTouchScreen() && playListPopover) || !isTouchScreen());
        case ConditionName.hasXToken:
            return !!params.xToken;
        case ConditionName.hasMovieDetails:
            return details.content_type !== null && details.content_type !== undefined;
        case ConditionName.hasMovieContentType:
            return details.content_type !== null;
        case ConditionName.hasMovieReleaseYear:
            return !!details.release_year;
        case ConditionName.hasSubtitle:
            return params.quiz !== "true" && !!subtitles && subtitles.length > 0 && !showMiniPlayer;
        case ConditionName.hasIMDB:
            return details.imdb_rate !== null;
        case ConditionName.hasSelectedTags:
            return !!selectedTags.length;
        case ConditionName.hasInputTagSearch:
            return !!inputTagSearch;
        case ConditionName.hasFullScreenParams:
            return params.fullscreen === "true";
        case ConditionName.hasPreviewParams:
            return params.preview === "true";
        case ConditionName.hasChart:
            return params.chart === "true" && !staticFormats(params.type!);
        case ConditionName.hasChartPoints:
            return !!chartPoints.length;
        case ConditionName.hasOnFinishedParams:
            return !!params.onFinished;
        case ConditionName.hasOnSnapshotParams:
            return !!params.onSnapshot;
        case ConditionName.hasXTokenParamOrSendXToken:
            const urlParams = new URLSearchParams(window.location.search);
            const xTokenParams = urlParams.get("xToken");
            const xTokenInCookie = Cookies.get("xToken");
            return getIsSendToken() === "true" || !!xTokenParams || !!xTokenInCookie;
        case ConditionName.hasUserAvatar:
            return !!avatar_url;
        case ConditionName.hasUserName:
            return !!name;
        case ConditionName.hasUserPhoneNumber:
            return !!phone_number;
        case ConditionName.hasScrollElementId:
            return !!params.scrollElementId && showMiniPlayer !== undefined && (isComplexDesktop || params.portrait === "false") && !isTouchScreen();
        case ConditionName.hasSportProvider:
            return params.provider === "sport";
        case ConditionName.hasSidebar:
            const container = document.getElementById("__container");
            return (
                isComplexDesktop &&
                ((playList && playList.length > 0 && (params.featureSet === undefined || params.featureSet.playlist !== "false")) ||
                    params.featureSet === undefined ||
                    params.featureSet.chat !== "false" ||
                    (recommendationList &&
                        recommendationList.length > 0 &&
                        (params.featureSet === undefined || params.featureSet.recommendationList !== "false")) ||
                    isLogin) &&
                (!!container ? container.getBoundingClientRect().width : window.innerWidth) > 900
            );
        case ConditionName.isBeforeRequest_Playlist_Chat_Recommendation:
            return (
                (params.type !== "live" && playList === undefined && (params.featureSet === undefined || params.featureSet.playlist !== "false")) ||
                ((params.featureSet === undefined || params.featureSet.recommendationList !== "false") && recommendationList === undefined)
            );
        case ConditionName.isBeforeRequestComments:
            return comments === undefined && !isTouchScreen() && (canAddComment || (!canAddComment && commentsCount > 0));
        case ConditionName.isVisibilityChange:
            return params.type === "live" && !document.pictureInPictureElement;
        case ConditionName.hasTrailer:
            return trailer.length !== 0;
        case ConditionName.hasHParam:
            return params.h === "true";
        case ConditionName.hasPreviewStart:
            return details.preview_start;
        case ConditionName.hasPreviewEnd:
            return details.preview_end;
        case ConditionName.hasSubtitles:
            return details.subtitles && details.subtitles.length > 0 && params.quiz !== "true";
        case ConditionName.hasHomeButtonClickFlag:
            return !!params.homeButtonClickFlag;
        case ConditionName.hasContinuousPlayback:
            return !!videoSettings.time && showContinuousePlayback && !params.t && params.featureSet?.continuousPlayback === "true";
        case ConditionName.hasPermittedLoadedFragment:
            return loadedFragmentsCount.length >= Number(getInitialLoadedFragmentCount());
        case ConditionName.hasAllParams:
            return allParams.length === Object.keys(VideoDataSliceState.params).length;
        case ConditionName.hasDefaultMessages:
            return !!defaultMessages.length;
        case ConditionName.hasPinMessage:
            return !!pinMessage;
        case ConditionName.hasCommentDefaultMessages:
            return !!commentDefaultMessages && !!commentDefaultMessages.length;
        case ConditionName.getRecommendationList:
            return params.portrait === "true" && params.quiz !== "true" && isFetchDetails;
        case ConditionName.getLiveDetailsInIntervals:
            return isLiveError && params.type === "live" && params.isGeneral !== "true";
        case ConditionName.getDetails:
            return !!params.type && params.id && params.isGeneral !== "true";
        case ConditionName.getMarkers:
            return (
                ["vod", "archive", "clip"].includes(String(params.type)) &&
                params.id &&
                params.isGeneral !== "true" &&
                params.quiz !== "true" &&
                isFetchDetails
            );
        case ConditionName.getPlayList:
            return !staticFormats(params.type!) && params.type !== "live" && !isFullMobilePortrait() && isFetchDetails;
        case ConditionName.firstGetDataIntervalAPI:
            return params.type === "live" && params.isGeneral !== "true";
        case ConditionName.getUserSetting:
            return isLogin && params.quiz !== "true" && isFetchDetails;
        case ConditionName.getVideoMetaData:
            return isLogin && params.quiz !== "true" && isFetchDetails;
        case ConditionName.getUserProfile:
            return !!params.xToken && isFetchDetails;
        case ConditionName.footerPaddingZero:
            return params.type !== "live" || (params.type === "live" && isTouchScreen()) || isTouchScreenPortrait();
        case ConditionName.manaulPostAPI:
            return !!selectedOptionId || emojiList1.length > 0 || emojiList2.length > 0;
        case ConditionName.canAccessVideo:
            return !!(params.h === "true" && !!getAccessToken());
        case ConditionName.canAddComment:
            return canAddComment;
        case ConditionName.canShowSubmittedComment:
            return canShowSubmittedComment;
        case ConditionName.canPlayVideo:
            return canPlayVideo;
        case ConditionName.chatEnabled:
            return chatEnabled;
        case ConditionName.filterLastGif:
            return (
                +qualityLevels[qualityLevels.length - 2] === +qualityLevels[settings.quality === -1 ? autoQuality ?? manualQuality! : manualQuality!!]
            );
        case ConditionName.instagramEmojiAnimation:
            return !isTouchScreen() || (isTouchScreen() && !activeElements);
        case ConditionName.handleOverflowHidden:
            return !isComplexDesktop || (isComplexDesktop && isFullScreen);
        case ConditionName.thresholdOnlineViewers:
            return !!onlineViewers && onlineViewers >= details.online_viewer_threshold;

        // *** Quiz Conditions ***
        case ConditionName.showQuizPopover:
            return params.xToken || firstQuizQuestion(quiz);
        case ConditionName.isQuizStatusEqual1:
            return !!quiz && Object.keys(quiz).length > 0 && quiz.questions.length > 0 && lastQuizQuestionStatus(quiz) === 1;
        case ConditionName.isQuizStatusEqual2:
            return !!quiz && Object.keys(quiz).length > 0 && quiz.questions.length > 0 && lastQuizQuestionStatus(quiz) === 2;
        case ConditionName.isQuizStatusEqual4:
            if (!!quiz && Object.keys(quiz).length > 0 && quiz.questions && quiz.questions.length > 0 && lastQuizQuestionStatus(quiz) === 4)
                return true;
            else return false;
        case ConditionName.isQuizEnd:
            return (
                !!quiz &&
                Object.keys(quiz).length > 0 &&
                quiz.questions &&
                quiz.number_of_questions === quiz.questions.length &&
                lastQuizQuestionStatus(quiz) === 4
            );
        case ConditionName.hasQuizParams:
            return params.quiz === "true";
        case ConditionName.hasQuiz:
            return !!quiz && Object.keys(quiz).length > 0 && !firstPlay;
        case ConditionName.hasQuizQuestion:
            return !!quiz && quiz.questions && quiz.questions.length;
        case ConditionName.hasChances:
            return chances !== -1;
        case ConditionName.sendUserTrackerRequest:
            return !!quiz && Object.keys(quiz).length > 0 && quiz.questions.length === 0 && !firstPlay && params.xToken;
        default:
            break;
    }
};
